import { render, staticRenderFns } from "./DashboardError.vue?vue&type=template&id=0238ee07&"
import script from "./DashboardError.vue?vue&type=script&lang=js&"
export * from "./DashboardError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports